import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signIn } from "../auth";
import "./Login.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const info = location.state?.message || "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await signIn(email.trim(), password);
      navigate("/", { replace: true });
    } catch (err) {
      setError(err?.message || "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  const platformLoginUrl = (
    process.env.REACT_APP_PLATFORM_URL || "https://platform.dev.tagnize.com"
  ).replace(/\/$/, "");

  return (
    <div className="bo-login">
      <aside className="bo-login-aside">
        <div className="bo-login-aside-inner">
          <span className="bo-login-kicker">Uso interno</span>
          <h2 className="bo-login-aside-title">Tagnize Ops</h2>
          <p className="bo-login-aside-copy">
            Consola de operaciones para el equipo Tagnize. No es la aplicación de clientes.
          </p>
          <ul className="bo-login-aside-list">
            <li>Gestión de tenants</li>
            <li>Términos contractuales</li>
            <li>Facturación simple</li>
          </ul>
        </div>
      </aside>

      <main className="bo-login-main">
        <div className="bo-login-card">
          <div className="bo-login-badge" role="status">
            Backoffice · PlatformAdmin
          </div>

          <header className="bo-login-header">
            <h1>Ingreso Ops</h1>
            <p>Solo personal autorizado de Tagnize</p>
          </header>

          {info && <p className="bo-login-info">{info}</p>}
          {error && <p className="bo-login-error">{error}</p>}

          <form onSubmit={handleSubmit} className="bo-login-form">
            <label>
              Email
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
                placeholder="admin@tagnize.com"
              />
            </label>
            <label>
              Contraseña
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                placeholder="Contraseña"
              />
            </label>
            <button type="submit" disabled={loading}>
              {loading ? "Verificando acceso…" : "Entrar al backoffice"}
            </button>
          </form>

          <p className="bo-login-footnote">
            ¿Buscás la app de tu empresa?{" "}
            <a href={`${platformLoginUrl}/login`} rel="noopener noreferrer">
              Ir a Platform (clientes)
            </a>
          </p>
        </div>
      </main>
    </div>
  );
}
